/**
 * Snackbar Component - Component Definition
 * ============================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { SnackbarController } from './controller';
import { SNACKBAR_TEMPLATE } from './template';
import { MODE_CLASSES, BASE_CLASSES, DEFAULTS, SnackbarMode, SnackbarPosition } from './constants';

export interface ISnackbarComponentBindings {
  position?: SnackbarPosition;
  mode?: SnackbarMode;
  title?: string;
  text?: string;
  showTitle?: boolean;
  showAction?: boolean;
  actionLabel?: string;
  onActionClick?: (args: { $event: Event }) => void;
}

export const snackbarComponentDefinition: IComponentOptions = {
  template: SNACKBAR_TEMPLATE,
  controller: SnackbarController,
  transclude: true,
  bindings: {
    mode: '@',
    position: '@',
    title: '@',
    text: '@',
    showTitle: '<',
    showAction: '<',
    actionLabel: '@',
    onActionClick: '&?'
  }
};

// Desde v2.0.0 los módulos viven en el namespace `ec.*` y este recuperó su
// nombre natural: hasta v1.3.0 se llamaba 'myApp.snackbarNotification' porque
// 'myApp.snackbar' ya estaba tomado por el mock legacy de las stories Y por un
// componente propio de la app easycancha.
//
// Ese era el síntoma de un problema mayor: `angular.module(name, deps)` REDEFINE
// el módulo si ya existe, borrando en silencio lo que tuviera registrado — sin
// error de DI, sin nada en consola. Mientras el design system compartió el
// namespace `myApp.*` con sus consumidores, cada nombre genérico (button, card,
// menu, tabs...) era una colisión esperando. Con `ec.*` la clase entera
// desaparece: el namespace es del design system y de nadie más.
export const MODULE_NAME = 'ec.snackbar';

const snackbarModule: IModule = angular
  .module(MODULE_NAME, [])
  .component('ecSnackbar', snackbarComponentDefinition);

export { SnackbarController, SNACKBAR_TEMPLATE, MODE_CLASSES, BASE_CLASSES, DEFAULTS };

export type { SnackbarMode, SnackbarPosition } from './constants';

export default snackbarModule;
